import React from 'react';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Bell, Crown, Users } from 'lucide-react';

const TIER_META = {
  flex: { label: 'Team Flex', color: 'bg-slate-500/15 text-slate-200 border-slate-400/40', accent: 'text-slate-100' },
  pro: { label: 'Pro Betrieb', color: 'bg-yellow-500/15 text-yellow-300 border-yellow-500/40', accent: 'text-yellow-300' },
  enterprise: { label: 'Enterprise', color: 'bg-purple-500/15 text-purple-300 border-purple-500/40', accent: 'text-purple-200' },
};

export const InhaberHeader = ({ company, subscription, seatsInfo, notifications = [], onLogout }) => {
  const tierKey = subscription?.tier;
  const tierMeta = tierKey ? TIER_META[tierKey] : null;
  const seatCap = subscription?.seat_cap ?? subscription?.employee_count;
  const seatsUsed = seatsInfo?.seats_used ?? subscription?.actual_employee_count;

  return (
    <header className="bg-black/80 backdrop-blur-md border-b border-yellow-500/30 sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center flex-wrap gap-3">
        <div className="flex items-center gap-4">
          <img src="/assets/smartvolt-logo.png" alt="Smartvolt" className="h-10" />
          <div>
            <h1 className="text-xl font-bold text-yellow-500">Chef-Cockpit</h1>
            <p className="text-sm text-gray-400">{company?.name}</p>
          </div>
        </div>
        <div className="flex items-center gap-3 flex-wrap">
          {tierMeta && (
            <div
              className={`flex items-center gap-2 px-3 py-1.5 rounded-full border ${tierMeta.color} text-sm font-semibold`}
              data-testid={`tier-badge-${tierKey}`}
              title={`Aktuelles Paket: ${tierMeta.label}`}
            >
              <Crown className="h-4 w-4" />
              <span>{tierMeta.label}</span>
              {(seatCap != null && Number.isFinite(Number(seatsUsed))) && (
                <>
                  <span className="mx-1 text-white/30">·</span>
                  <Users className="h-3.5 w-3.5" />
                  <span className={tierMeta.accent} data-testid="tier-seat-usage">
                    {seatsUsed}/{seatCap === 999 ? '∞' : seatCap} Plätze
                  </span>
                </>
              )}
            </div>
          )}
          {subscription && (
            <Badge className={`${
              subscription.status === 'active' ? 'bg-green-500/20 text-green-400 border-green-500/30' :
              subscription.status === 'trial' ? 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30' :
              'bg-gray-500/20 text-gray-400 border-gray-500/30'
            } border`} data-testid="subscription-status-badge">
              {subscription.status === 'trial' ? '14-Tage-Test' :
               subscription.status === 'active' ? 'Abo aktiv' : subscription.status}
            </Badge>
          )}
          <div className="relative">
            <Bell className="h-6 w-6 text-gray-400 hover:text-yellow-500 cursor-pointer" />
            {notifications.length > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                {notifications.length}
              </span>
            )}
          </div>
          <Button
            variant="outline"
            onClick={onLogout}
            className="border-gray-700 text-gray-300"
            data-testid="logout-btn"
          >
            Abmelden
          </Button>
        </div>
      </div>
    </header>
  );
};
